import * as React from 'react';
import * as styles from './Basic.css';
import { Layout } from '../Layout';

export interface IBasicProps {
  name: React.ReactNode;
  price: React.ReactNode;
  callback: React.ReactNode;
  labels: React.ReactNode;
  call: React.ReactNode;
  messageButton: React.ReactNode;
}

export const Basic: React.FC<IBasicProps> = props => {
  const { name, price, callback, labels, call, messageButton } = props;

  return (
    <div className={styles['basic']}>
      <Layout>
        {labels}
        {name}
        {price}
        <div className={styles['controls']}>
          {call}
          {messageButton}
          {callback}
        </div>
      </Layout>
    </div>
  );
};
